export default {"src":"/_next/static/media/biologyBg.bc19899e.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};